<template>
  <div class="main-wrap catering">
    <div class="header-tab" v-if="isshow">
      <h3>{{ activeName=='first'?'館内｜出餐摘要':activeName=='second'?'試吃｜出餐摘要':activeName=='third'?'院外｜出餐摘要':'陪宿｜出餐摘要'   }}</h3>
      <router-link :to="{path:'/Catering',query:{activeName: activeName}}"><img src="@/assets/image/ico7.svg"></router-link>
    </div>
    <div class="list-body" v-if="isshow">
      <div class="container">
        <div class="list-header"><i :class="activeName=='first'?'iconfont icon-ico18':activeName=='second'?'iconfont icon-ico13':activeName=='third'?'iconfont icon-ico14': 'iconfont icon-ico15'"></i>{{
            activeName=='first'? $route.query.roomName :activeName=='second'?$route.query.index:activeName=='third'?$route.query.index:$route.query.roomName}}</div>
        <div class="items">
          <div v-for="(item,index) in tableDate" :key="index" class="item">
            <div class="_num"><span>{{index + 1}}</span></div>
            <div class="_header">
              <div class="_title">{{ item.user_name }} <span class="_card">{{ $itemDate.find(it => it.id == item.item).name}}</span></div>
              <a  style="color: #3C3C3C" @click="checkOrder(item)">查看訂單</a>
            </div>
            <div class="_body">
              <div class="_list">
                <div class="_td" v-if="activeName == 'first' || activeName == 'third'">
                  <div class="_n">生產日期</div>
                  <div class="_x">{{item.date?item.date.replaceAll('-','/'):''}}</div>
                </div>
                <div class="_td" v-if="activeName == 'fourth'">
                  <div class="_n">出餐房號</div>
                  <div class="_x">皇 00102</div>
                </div>
                <div class="_td">
                  <div class="_n">出餐日期 / 餐期</div>
                  <div class="_x">{{ item.start_date?item.start_date.replaceAll('-','/'):'' }}<span style="margin-left: 10px">{{ $stage.find(it => it.id == item.start_stage).name}}</span></div>
                </div>

                <div class="_td _last" style="width: 150px">
                  <a v-if="(activeName == 'first'||activeName == 'fourth')&& $isPermission('agency_meal_query.edit_room')" class="btn btn-primary" style="width: 150px;text-align: center" @click="updateRoom(item)">換房</a>
                </div>
              </div>
              <div class="_list">
                <div class="_td" v-if="activeName == 'first' || activeName == 'third'">
                  <div class="_n">生產方式</div>
                  <div class="_x">{{ item.way == 1?'自然產':'剖腹產'}}</div>
                </div>
                <div class="_td" v-if="activeName == 'fourth'">
                  <div class="_n" style="background: transparent"></div>
                  <div class="_x"></div>
                </div>
                <div class="_td" v-if="activeName == 'first' || activeName == 'third' || activeName == 'fourth'">
                  <div class="_n">預計終止日期 / 餐期</div>
                  <div class="_x">{{ item.end_date?item.end_date.replaceAll('-','/'):'' }}<span style="margin-left: 10px">{{ $stage.find(it => it.id == item.end_stage).name}}</span></div>
                </div>
                <div class="_td" v-if="activeName == 'second'">
                  <div class="_n">備註</div>
                  <div class="_x">{{ item.card_remark[0].content }}</div>
                </div>
<!--                <div class="_td _last"  style="width: 150px">-->
<!--                  <a v-if="(activeName == 'first'||activeName == 'fourth')&& $isPermission('agency_meal_query.edit_order')" style="width: 150px;text-align: center" class="btn btn-primary" @click="termination(item)" >提前終止</a>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <orderDetail v-else :orderDetail="orderDetail"  :activeName="activeName" @done="isshow = true"></orderDetail>
    <updateRoomDig ref="updateRoomDig" @done="roomOrderList"></updateRoomDig>
    <Termination ref="Termination"></Termination>
  </div>
</template>

<script>
import { roomOrderList } from "@/api";

export default {
  name: "List",
  computed: {

  },
  components: {
    updateRoomDig: () => import('@/views/Catering/updateRoomDig.vue'),
    Termination: () => import('@/views/Catering/Termination.vue'),
    orderDetail: () => import('@/views/Catering/orderDetail.vue')
  },
  data() {
    return {
      activeName:'first',
      isshow: true,
      mold: 1,
      tableDate:[],
      orderDetail:{}
    }
  },
  created() {

  },
  mounted() {
    this.activeName = this.$route.query.activeName
    this.mold = this.activeName == 'first'?1:this.activeName == 'second'?3:this.activeName == 'third'?2:4
    this.roomOrderList()
  },
  beforeDestroy() {
  },
  methods:{


    roomOrderList(){
      roomOrderList({room_id:this.$route.query.roomID,mold:this.mold,order_id:this.$route.query.orderID}).then(res =>{
           this.tableDate = res.data.list
      })
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },
    updateRoom(item){
      this.$refs.updateRoomDig.init(item)
    },
    termination(item){
      this.$refs.Termination.init(item)
    },
    checkOrder(item){
      this.orderDetail = item
      this.isshow = false
    }
  }
};
</script>

<style lang="scss" scoped>
.header-tab{
  display: flex;
  justify-content: space-between;
  img{
    width: 30px;
    height: 30px;
    object-fit: contain;
    margin-top: 20px;
    cursor: pointer;
  }
}
._card {
  padding: 5px 20px;
  border: 1px solid #DBBD80;
  border-radius: 5px;
  font-size: 16px;
  line-height: 16px;
  color: #DBBD80;
  margin-left: 30px;
}
._title{
  font-size: 30px;
  display: flex;
  align-items: center;
}
</style>
